export default __webpack_public_path__ + "static/media/support-icon.47640cc3.svg";